/**
===================================================
Module: frontend.src.components.SessionsList.tsx
Description: All sessions list component
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React from "react";
import { useTranslation } from "react-i18next";
import { SessionsListProps } from "../types";
import SessionCard from "./SessionCard";

interface SessionsListPropsExtended extends SessionsListProps {
  retentionDays?: number;
}

const SessionsList: React.FC<SessionsListPropsExtended> = ({
  sessions,
  onSessionClick,
  isLoading,
  isSelectionMode = false,
  selectedSessions = new Set(),
  onSessionSelect,
  onCancelSelection,
  retentionDays = 30,
}) => {
  const { t } = useTranslation('sessions');

  if (isLoading) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {t('loading')}
      </div>
    );
  }

  return (
    <div>
      {sessions.length === 0 ? (
        <div className="empty-state">
          {t('noSessions')}
        </div>
      ) : (
        <div className="sessions-list">
          {sessions.map((session) => (
            <SessionCard
              key={session.id}
              session={session}
              onClick={onSessionClick}
              isSelectionMode={isSelectionMode}
              isSelected={selectedSessions.has(session.id)}
              onSelect={onSessionSelect}
              retentionDays={retentionDays}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SessionsList;
